import React, { useState, useEffect } from 'react'
import '../css/Navbar.css';
import TopNav from './TopNav';
import { Link,useLocation } from 'react-router-dom';
function Navbar() {
    const [navHeight, setnavHeight] = useState(110)
    const [navColor, setnavColor] = useState(110)
    let location =useLocation()
    
    window.addEventListener("scroll", () => {
        let y = window.scrollY
        if (y > 300) {
            setnavHeight(70)
            setnavColor('#121731')
        }
        if (y < 200) {
            setnavHeight(110)
            setnavColor('#121731b7')
        }
    })
    
    return (
        <>
        <div className={`navDiv position-fixed top-0`}>
                <TopNav/>
            <nav class="navbar navbar-expand-lg navbar-dark " style={window.innerWidth > 999 ? { height: ` ${navHeight}px`,background:`${navColor}` } : { height: "",background:"#121731" }} >

                {/* top nav */}

                <a class="navbar-brand" href="#">
                    <img src="https://i.postimg.cc/nLbdNJ29/dots-logo.png" height="50" alt="mdb logo" />
                </a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#basicExampleNav"
                    aria-controls="basicExampleNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class={`collapse navbar-collapse ${window.innerWidth > 999 && "d-flex justify-content-center"}  `} id="basicExampleNav">

                    <ul class="navbar-nav mr-auto  ">
                        <li class="nav-item  mx-3">
                            <Link to="/" class="nav-link" ><ion-icon name="home-outline"></ion-icon> Home
                                <span class="sr-only">(current)</span>
                            </Link>
                        </li>
                        <li class="nav-item mx-3 dropdown">
                            <a class="nav-link dropdown-toggle" id="organizationMenuLink" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                                <ion-icon name="briefcase-outline"></ion-icon> Organization
                            </a>
                            <div class="dropdown-menu dropdown-primary" aria-labelledby="organizationMenuLink">
                                <Link class="dropdown-item" to="/">School</Link>
                                <Link class="dropdown-item" to="/">University</Link>
                                <Link class="dropdown-item" to="/">Tuition</Link>
                            </div>
                        </li>
                        <li class="nav-item mx-3 dropdown">
                            <a class="nav-link dropdown-toggle" id="coursesMenuLink" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                                <ion-icon name="clipboard-outline"></ion-icon> Courses
                            </a>
                            <div class="dropdown-menu dropdown-primary" aria-labelledby="coursesMenuLink">
                                <Link class="dropdown-item" to="/">Python</Link>
                                <Link class="dropdown-item" to="/">Php</Link>
                                <Link class="dropdown-item" to="/">JavaScript</Link>
                                <Link class="dropdown-item" to="/">Java</Link>
                            </div>
                        </li>

                        <li class="nav-item mx-3 dropdown">
                            <a class="nav-link dropdown-toggle" id="classesMenuLink" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                                <ion-icon name="school-outline"></ion-icon> Classes
                            </a>
                            <div class="dropdown-menu dropdown-primary" aria-labelledby="classesMenuLink">
                                <Link class="dropdown-item" to="/">Online classes</Link>
                                <Link class="dropdown-item" to="/">Tution classes</Link>
                            </div>
                        </li>
                        <li class="nav-item mx-3">
                            <Link class="nav-link" to="/event"><ion-icon name="calendar-outline"></ion-icon> Event</Link>
                        </li>
                        <li class="nav-item mx-3">
                            <Link to="/gallery" class="nav-link" href="#"><ion-icon name="images-outline"></ion-icon> Gallery</Link>
                        </li>
                        <li class="nav-item mx-3">
                            <Link class="nav-link" to="/about"><ion-icon name="people-outline"></ion-icon> About</Link>
                        </li>
                        <li class="nav-item mx-3">
                            <Link class="nav-link" to="/contact"><ion-icon name="call-outline"></ion-icon> Contact</Link>
                        </li>

                        <button class="btn btn-deep-orange white-text letter-dis-1" >Log in</button>
                        <button class="btn btn-deep-orange white-text letter-dis-1  " >Sign up</button>

                    </ul>


                </div>

            </nav>
            </div>
        </>
    )
}

export default Navbar
